module.exports = __webpack_public_path__ + "static/logo-repubblica-italiana-7fbd499462dce2296691118dcbbcf3ca.jpg";